var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 205.847,
  height: 179.998,
  viewBox: "0 0 205.847 179.998"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.102
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b3b3b3",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#b3b3b3",
  stopOpacity: 0.102
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3b3b3",
  stopOpacity: 0.051
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  y2: 0,
  xlinkHref: "#d"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.051
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5601 -18869.084)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.067,209.674,0,216.161V53.569L69.067,47.08Z",
  transform: "translate(5601 18832.922)",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.81,209.674l69.067,6.487V53.569L297.81,47.08Z",
  transform: "translate(5372.257 18832.922)",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M663.333,209.674l-67.713,6.487V53.569l67.713-6.489Z",
  transform: "translate(5143.514 18832.922)",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.6,211.3,9.49,217.532V61.3L76.6,55.07Z",
  transform: "translate(5593.711 18826.785)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.87,211.3l67.11,6.236V61.3L298.87,55.07Z",
  transform: "translate(5371.443 18826.785)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M655.352,211.3l-67.112,6.236V61.3l67.112-6.234Z",
  transform: "translate(5149.182 18826.785)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.037,116.94,79.06,118.728V142.2h43.276v-8.486l7.7-.269,11.735,3.623v-16.5Z",
  transform: "translate(5540.275 18779.266)",
  fill: "#b5b5c1",
  opacity: 0.65
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.391,613.615l-57.211,5.5v-20.9l57.211-5.5Z",
  transform: "translate(5560.921 18413.834)",
  fill: "#b5b5c1",
  opacity: 0.65
}), /*#__PURE__*/React.createElement("rect", {
  width: 24.938,
  height: 19.07,
  transform: "translate(5704.049 19011.313)",
  fill: "#b5b5c1",
  opacity: 0.65
}), /*#__PURE__*/React.createElement("path", {
  d: "M707.761,573.744l-38.871,3.3v-25.3l38.871-3.3Z",
  transform: "translate(5087.236 18447.836)",
  fill: "#b5b5c1",
  opacity: 0.65
}), /*#__PURE__*/React.createElement("path", {
  d: "M853.237,78.357c0,9.073-15.858,34.764-15.858,34.764S821.52,87.429,821.52,78.357s7.1-16.427,15.858-16.427S853.237,69.284,853.237,78.357Z",
  transform: "translate(4933.778 18807.154)",
  fill: "url(#d)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.794,
  cy: 4.965,
  rx: 4.794,
  ry: 4.965,
  transform: "translate(5766.363 18879.4)",
  fill: "url(#e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M855.971,84.286c0,8.105-14.676,31.056-14.676,31.056S826.62,92.382,826.62,84.286a14.675,14.675,0,1,1,29.35,0Z",
  transform: "translate(4929.861 18801.256)",
  fill: "#07092b"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.437,
  cy: 4.437,
  r: 4.437,
  transform: "translate(5766.72 18880.08)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.4,521.213c0,9.137-16.329,35.019-16.329,35.019s-16.329-25.873-16.329-35.019a16.331,16.331,0,1,1,32.658,0Z",
  transform: "translate(5379.866 18467.094)",
  fill: "url(#f)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.937,
  cy: 5.002,
  rx: 4.937,
  ry: 5.002,
  transform: "translate(5631.996 18982.158)",
  fill: "url(#g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.211,527.046c0,8.105-14.676,31.056-14.676,31.056s-14.676-22.96-14.676-31.056a14.675,14.675,0,1,1,29.35,0Z",
  transform: "translate(5374.397 18461.178)",
  fill: "#ff2f2f"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.437,
  cy: 4.437,
  r: 4.437,
  transform: "translate(5632.497 18982.764)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("line", {
  y1: 12.063,
  x2: 19.1,
  transform: "translate(5650.761 18994.156)",
  fill: "none",
  stroke: "#ff4b4b",
  strokeWidth: 5,
  strokeDasharray: "5 3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.461-.02,19-.018",
  transform: "translate(5669.961 18994.475)",
  fill: "none",
  stroke: "#7b7b84",
  strokeWidth: 5,
  strokeDasharray: "5 3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.649-.02H19",
  transform: "translate(5651.312 18994.477)",
  fill: "none",
  stroke: "#ff4b4b",
  strokeWidth: 5,
  strokeDasharray: "5 3"
}), /*#__PURE__*/React.createElement("line", {
  x1: 36.19,
  y2: 75.898,
  transform: "translate(5735.203 18919.967)",
  fill: "none",
  stroke: "#7b7b84",
  strokeWidth: 5,
  strokeDasharray: "5 3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5736.915,18992.332l-2.349-1.283h2.349Z",
  transform: "translate(0.497 0.694)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.349,1.281,0,0H2.349Z",
  transform: "translate(5739.434 18993.982) rotate(-154.5)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.011,
  height: 1.005,
  transform: "translate(5733.695 18990.949)",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/location-chart.fbd74706.svg";
export { SvgComponent as ReactComponent };